module.exports = __webpack_public_path__ + "img/how.9e040bff.webp";